import '../dashboard/dashboard.css';
import '../card/card.css';
import '../submission/submission.css';
import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CoverDisplay from '../components/ImagesPage';
import BannerImage from '../assets/Space.jpg';

const TARGET_TAG_NAME = 'Mewtwo - Base Set';

const toGradeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : -1;
};

const sortCardsByGrade = (cards = []) => {
  return [...cards].sort((a, b) => {
    const gradeDifference = toGradeNumber(a.card_grade_number) - toGradeNumber(b.card_grade_number);
    if (gradeDifference !== 0) {
      return gradeDifference;
    }

    return String(a.card_name || '').localeCompare(String(b.card_name || ''));
  });
};

function MewtwoBaseSetPage() {
  const [selectedTag, setSelectedTag] = useState(null);
  const [selectedTagCards, setSelectedTagCards] = useState([]);
  const [selectedTagTotals, setSelectedTagTotals] = useState(null);
  const [tagWallLoading, setTagWallLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let mounted = true;

    const loadSelectedTagWall = async () => {
      try {
        setTagWallLoading(true);
        setErrorMessage('');

        const tagResponse = await Axios.get('https://api.alientrader.cards/tags');
        const matchingTag = (tagResponse.data || []).find(
          (item) => String(item.tag_name || '').toLowerCase() === TARGET_TAG_NAME.toLowerCase()
        );

        if (!matchingTag) {
          throw new Error(`Tag not found: ${TARGET_TAG_NAME}`);
        }

        const response = await Axios.get(`https://api.alientrader.cards/tags/${matchingTag.tag_id}/cards`);

        if (mounted) {
          setSelectedTag(response.data?.tag || matchingTag);
          setSelectedTagCards(sortCardsByGrade(response.data?.cards || []));
          setSelectedTagTotals(response.data?.totals || null);
        }
      } catch (error) {
        console.error('Error fetching Mewtwo Base Set cards:', error);
        if (mounted) {
          setSelectedTag(null);
          setSelectedTagCards([]);
          setSelectedTagTotals(null);
          setErrorMessage('Unable to load the Mewtwo - Base Set page right now.');
        }
      } finally {
        if (mounted) {
          setTagWallLoading(false);
        }
      }
    };

    loadSelectedTagWall();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="imagesPage">
      <div
        className="subTopBG"
        style={{
          backgroundImage: `url(${BannerImage})`,
          backgroundPosition: 'center -40px',
        }}
      >
        <div className="actions" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="subBack"></div>
          <div className="sub" style={{ color: '#f4f7fb' }}></div>
          <div className="subEdit" style={{ width: 'auto', marginRight: '0' }}></div>
        </div>
        <div className="subHeader">{TARGET_TAG_NAME}</div>
      </div>

      <div className="subPositionAdjust" style={{ top: '-130px' }}>
        <Container fluid style={{ paddingLeft: '30px', paddingRight: '30px' }}>
          <Row className='d-flex justify-content-center'>
            <Col xl={10} className='custom-info-box shadow-sm'>
              <Row>
                <div className='custom-info-header'>
                  {selectedTag?.tag_name || TARGET_TAG_NAME}
                </div>
              </Row>
              <Row>
                <div className='custom-info-misc' style={{ paddingBottom: '12px' }}>
                  {tagWallLoading
                    ? 'Loading cards...'
                    : errorMessage
                      ? errorMessage
                      : `${selectedTagCards.length} cards${selectedTagTotals ? ` | Cost $${Number(selectedTagTotals.total_cost || 0).toFixed(2)} | Sold $${Number(selectedTagTotals.total_sold_price || 0).toFixed(2)} | Profit $${Number(selectedTagTotals.total_profit || 0).toFixed(2)}` : ''}`}
                </div>
              </Row>
              <Row className='subCardWall d-flex align-items-center justify-content-center'>
                {tagWallLoading ? (
                  <Col>
                    <div className='custom-info-misc'>Loading card wall...</div>
                  </Col>
                ) : selectedTagCards.length > 0 ? (
                  selectedTagCards.map((item, index) => (
                    <Col className='imagesPageRow d-flex align-items-center justify-content-center' key={`mewtwo-base-set-${item.card_id}`}>
                      <CoverDisplay key={index} image={item} />
                    </Col>
                  ))
                ) : (
                  <Col>
                    <div className='custom-info-misc'>
                      {errorMessage || 'No cards are assigned to this tag yet.'}
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default MewtwoBaseSetPage;
